import React, { useState, useEffect } from "react";
import "./styles.css";
import { Feedback, Save, Cancel, FeedBackInput } from "../Translation";
import { FeedbackApi } from "../Api";
function Like(props: any) {
  const {
    handleToggle,
    setLikeView,
    likeView,
    messageIndex,
    selectedLanguage,
    answerId,
  } = props;
  const [textareaDisabled, setTextareaDisabled] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [saveBtnStyle, SetSaveBtnStyle] = useState("btn disable");

  const debounce = (func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleFeedbackTextChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setFeedbackText(event.target.value);
  };

  const debouncedHandleFeedbackTextChange = debounce(
    handleFeedbackTextChange,
    400
  );

  const handleSaveFeedback = () => {
    setLikeView(false);
    handleToggle(messageIndex);
    FeedbackApi(answerId, true, feedbackText);
  };
  const handleCancelFeedback = () => {
    setLikeView(false);
  };

  useEffect(() => {
    if (feedbackText.trim().length < 4) {
      setTextareaDisabled(true);
      SetSaveBtnStyle("btn disable");
    } else {
      setTextareaDisabled(false);
      SetSaveBtnStyle("btn save");
    }
  }, [feedbackText]);

  return (
    <>
      {likeView && (
        <div className="backDrop">
          <div className="textContainer">
            <span className="headerFeedback1">
              {(Feedback as any)[selectedLanguage]}
            </span>

            <textarea
              className="textarea"
              cols={20}
              rows={4}
              placeholder={(FeedBackInput as any)[selectedLanguage]}
              onChange={(e) => debouncedHandleFeedbackTextChange(e)}
            />
            <div className="buttonGroup">
              <button className="btn cancel" onClick={handleCancelFeedback}>
                {(Cancel as any)[selectedLanguage]}
              </button>
              <button
                className={saveBtnStyle}
                onClick={handleSaveFeedback}
                disabled={textareaDisabled}
              >
                {(Save as any)[selectedLanguage]}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Like;
